import { Box, styled } from '@mui/material';

export const HorizontalButtonContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});
